export default "__VITE_ASSET__05526eda__"